export default {
    install(Vue, { store, store_path }) {
        if (!store) {
            console.error("[Dr Settings Plugin] No store specified");

            return false;
        }

        if (!store_path) {
            console.error("[Dr Settings Plugin] No store_path specified");

            return false;
        }

        const sizes = {
            "text-xs": { "font-size": "0.75rem", "line-height": "1rem" },
            "text-sm": { "font-size": "0.875rem", "line-height": "1.25rem" },
            "text-base": { "font-size": "1rem", "line-height": "1.5rem" },
            "text-lg": { "font-size": "1.125rem", "line-height": "1.75rem" },
            "text-xl": { "font-size": "1.25rem", "line-height": "1.75rem" },
            "text-2xl": { "font-size": "1.5rem", "line-height": "2rem" },
            "text-3xl": { "font-size": "1.875rem", "line-height": "2.25rem" },
            "text-4xl": { "font-size": "2.25rem", "line-height": "2.5rem" },
            "text-5xl": { "font-size": "3rem", "line-height": "1" },
            "text-6xl": { "font-size": "3.75rem", "line-height": "1" },
            "text-7xl": { "font-size": "4.5rem", "line-height": "1" },
            "text-8xl": { "font-size": "6rem", "line-height": "1" },
            "text-9xl": { "font-size": "8rem", "line-height": "1" }
        };
        const weights = {
            "font-thin": "100",
            "font-extralight": "200",
            "font-light": "300",
            "font-normal": "400",
            "font-medium": "500",
            "font-semibold": "600",
            "font-bold": "700",
            "font-extrabold": "800",
            "font-black": "900"
        };

        // add more later
        const border_width = {
            "border-0": "0px",
            "border-2": "2px",
            "border-4": "4px",
            "border-8": "8px",
            border: "1px"
        };

        function getFontSize(value) {
            return sizes[value] || sizes["text-base"];
        }

        function getFontWeight(value) {
            return weights[value] || weights["font-normal"];
        }

        function colorOrUrl(type, value) {
            return type === "image" ? `url('${value}')` : value;
        }
        function getBorderWidth(value) {
            return border_width[value] || border_width["border"];
        }

        function setFavIcon(settings) {
            let favicon = window.document.querySelector('[rel="icon"]');
            if (favicon) {
                favicon.href = settings.common.favicon || "favicon.png";
            }
        }

        function applySettings(obj, path) {
            if (!path) {
                path = ["-"];
            }
            Object.keys(obj).forEach(key => {
                if (obj[key]) {
                    let path2 = Object.values(path);
                    path2.push(key.replaceAll("_", "-"));
                    if (typeof obj[key] === "object") {
                        applySettings(obj[key], path2);
                    } else if (key === "font_size") {
                        path2.pop();
                        applySettings(getFontSize(obj[key]), path2);
                    } else {
                        let value = obj[key];

                        if (key === "background_value") {
                            value = colorOrUrl(
                                obj["background_type"],
                                obj["background_value"]
                            );
                            path2.pop();
                            path2.push("background");
                        } else if (key === "font_weight") {
                            value = getFontWeight(value);
                        } else if (key === "border_weight") {
                            value = getBorderWidth(value);
                        } else if (key === "font_family") {
                            const link = document.createElement("link");
                            link.rel = "stylesheet";
                            link.href = `https://fonts.googleapis.com/css2?family=${value}:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap`;
                            document.head.appendChild(link);
                            value = `'${value}', sans-serif`;
                        }
                        document.documentElement.style.setProperty(
                            path2.join("-"),
                            value
                        );
                    }
                }
            });
        }

        function createManifestLink(link) {
            link = document.createElement("link");
            link.rel = "manifest";
            document.head.appendChild(link);
            return link;
        }

        function createMeta(name, content, meta) {
            meta = document.createElement("meta");
            meta.name = name;
            meta.content = content;
            document.head.appendChild(meta);
        }
        function setupManifest(pwa_settings) {
            const manifest = createManifestLink();
            createMeta("msapplication-TileColor", "#ffffff");
            createMeta("msapplication-TileImage", "/ms-icon-144x144.png");
            createMeta("theme-color", "#ffffff");
            manifest.href =
                "data:application/manifest+json," +
                encodeURIComponent(
                    JSON.stringify({
                        name: pwa_settings.name,
                        short_name: pwa_settings.short_name,
                        start_url: pwa_settings.start_url,
                        display: "fullscreen",
                        theme_color: pwa_settings.theme_color,
                        background_color: pwa_settings.background_color,
                        icons: Object.entries(pwa_settings.icons).map(v => {
                            return {
                                src: v[1].src,
                                type: v[1].type,
                                sizes: v[0] + "x" + v[0]
                            };
                        })
                    })
                );
        }

        store.watch(
            (state, getters) => getters[store_path],
            settings => {
                setFavIcon(settings);
                applySettings(settings);
                setupManifest(settings.common.pwa.manifest);
            }
        );
    }
};
